class Queue {
  tasks = [];
  concurrency = 10;
  waiter;
  isScheduled = false;
  constructor(concurrency, waiter = (cb) => cb()) {
    this.concurrency = concurrency;
    this.waiter = waiter;
  }
  add(task) {
    const p = new Promise((resolve) => {
      this.tasks.push(() => resolve(task()));
    });
    this.scheduleFlush();
    return p;
  }
  scheduleFlush() {
    if (this.isScheduled) {
      return;
    }
    this.isScheduled = true;
    this.waiter(() => this.flush());
  }
  flush() {
    this.run(this.tasks.splice(0, this.concurrency));
    this.isScheduled = false;
    if (this.tasks.length > 0) {
      this.scheduleFlush();
    }
  }
  run(tasks) {
    let task;
    while (task = tasks.shift()) {
      task();
    }
  }
}
export {
  Queue
};
//# sourceMappingURL=Queue.js.map
